export enum StatusCode {
	INTERNAL_SERVER_ERROR = 500,
	SERVICE_UNAVAILABLE = 503,
	BAD_GATEWAY = 502,
	GATEWAY_TIMEOUT = 504,
	BAD_REQUEST = 400,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	NOT_FOUND = 404,
	CONFLICT_RESPONSE_ERROR = 409,
	VALIDATION_ERROR = 422,
}
